export default {
  title: '候选人管理',
  registeredList: '自社候选人',
  addEmployee: '添加候选人',
  editEmployee: '编辑候选人',
  detailTitle: '候选人详情',
  addCandidateDialog: {
    addMethod: '添加方式',
    directAdd: '直接添加',
    aiParseResume: 'AI 解析简历',
    uploadResume: '上传简历',
    uploadTips: '限 jpg/jpeg/png/doc/xlsx/xls/pdf 格式，单个文件需小于 {size} MB',
    uploadRequired: '请先上传简历',
    startParse: '开始解析'
  },
  selectingCandidates: '选考中候选人',
  selectionDetail: '选考详情',
  selectingCandidateIng: '选考中候选人',
  detail: {
    ageUnit: '岁',
    workStatus: {
      employed: '在职',
      pending: '待入职',
      resigned: '已离职',
    },
    visaTasks: {
      emptyText: '尚未创建签证任务',
      columns: {
        id: '编号',
        type: '类型',
        dataCompletion: '资料完成度',
        status: '状态',
        creator: '创建人',
        createTime: '创建时间',
        operation: '操作',
      },
      types: {
        change: '变更',
        update: '更新',
        firstApplication: '首次申请',
      },
      statuses: {
        inProgress: '进行中',
        submitted: '已提交',
        applicationSuccess: '申请成功',
        applicationFailed: '申请失败',
      },
      actions: {
        edit: '编辑',
        view: '查看',
      },
    },
  },
  summary: {
    title: '候选人信息摘要',
    age: '岁',
    nearestStation: '日语 N3',
    workExperience: '工作经历方面',
    advantages: '她的优势',
    currentStatus: '目前她在就业',
    salaryExpectation: '关于期望薪资',
  },
  detailTabs: {
    basicInfo: '基本信息',
    residenceInfo: '在留卡/保有资格',
    experience: '学历/职历',
    documents: '其他资料',
    visaTasks: '投递记录',
  },
  tableStats: '合计: #total# 件，已选择: #selected# 件',
  tableStatsWithOutTotal: '合计: #total# 件，已选择: #selected# 件',
  filters: {
    enterpriseName: '应聘企业',
    name: '候选人',
    country: '国籍',
    visaType: '在留资格',
    visaStatus: '签证状态',
    department: '所属先',
    employmentType: '雇佣形态',
    japaneseLevel: '日语水平',
    industry: '行业',
    candidateId: '候选人 ID',
    recentIndustry: '最近从事行业',
    desiredJobIndustry: '希望从事行业',
    specialSkillIndustry: '特定技能资格行业',
    specialSkillIndustry1: '特定技能 1 号资格',
    specialSkillIndustry2: '特定技能 2 号资格',
    applicationChannel: '渠道来源',
    source: '来源',
    registrationDate: '添加时间',
    creator: '添加人',
    startDate: '开始日期',
    endDate: '结束日期',
    applicationDate: '应聘日期',
    placeholder: '请输入',
    placeholderSelect: '请选择',
    moreFilters: '更多筛选条件',
    search: '搜索',
    reset: '重置',
  },
  tabs: {
    employed: '在职',
    pending: '待入职',
    resigned: '已离职',
  },
  table: {
    name: '姓名',
    candidate: '候选人',
    candidateId: '候选人 ID',
    aiScore: 'AI 评分',
    basicInfo: '基本信息',
    visaStatus: '在留资格',
    japaneseLevel: '日语水平',
    appliedJobCount: '应聘职位个数',
    recentIndustry: '最近从事行业',
    desiredJobIndustry: '希望从事行业',
    specialSkillIndustry: '特定技能资格行业',
    specialSkillIndustry1: '特定技能 1 号资格',
    specialSkillIndustry2: '特定技能 2 号资格',
    source: '来源',
    applicationChannel: '渠道来源',
    registrationDate: '添加时间',
    creator: '添加人',
    country: '国籍·地区',
    department: '所属先',
    position: '岗位名称',
    phone: '手机号码',
    email: '电子邮箱',
    employmentType: '雇佣形态',
    visaStatusLabel: '签证状态',
    enterpriseName: '应聘企业',
    actions: '操作',
    detail: '详情',
    edit: '编辑',
    manageVisa: '管理签证',
    delete: '删除',
  },
  status: {
    normal: '正常',
    expiredSoon: '即将过期',
    expired: '过期',
    notEntered: '未录入',
  },
  messages: {
    searchSuccess: '查询成功',
    resetSuccess: '已重置筛选条件',
    pleaseComplete: '请完善信息',
    fetchListFailed: '获取员工列表失败',
  },
  emptyState: {
    noResults: '查询无结果',
    tryModifyFilters: '可尝试修改查询条件',
    noEmployees: '尚未添加员工',
  },
  period: {
    year: '年',
    month: '月',
    day: '日',
  },
  stats: {
    total: '共计',
    selected: '条，选中',
    items: '条',
  },
  editSteps: {
    employeeInfo: '基本信息',
    residenceInfo: '在留卡/保有资格',
    experience: '学历/职历',
    documents: '其他资料',
  },
  form: {
    addDepartment: '应聘渠道管理',
    basicInfo: {
      title: '基本信息',
      name: '姓名',
      nickname: '昵称',
      nameKana: '姓名(假名)',
      applicationChannel: '应聘渠道',
      nationality: '国籍·地区',
      country: '国家',
      birthday: '出生日期',
      birthDate: '出生日期',
      gender: '性别',
      genderMale: '男',
      genderFemale: '女',
      hasSpouse: '有无配偶',
      hasSpouseYes: '有',
      hasSpouseNo: '无',
      dependents: '扶养家属',
      passportNumber: '护照号码',
      phone: '手机号码',
      email: '电子邮箱',
      residenceCardAddress: '在留卡地址',
      nearestStation: '最近车站',
    },
    employmentStatus: {
      title: '就业·转职状况',
      employmentStatus: '求职状态',
      desiredJobStartDate: '希望转职时间',
      desiredJobIndustry: '希望从事行业',
    },
    selfRecommendation: {
      title: '自我推荐·求职动机',
      selfPr: '自我推荐',
      reasonForApplication: '求职动机',
    },
    employmentInfo: {
      title: '雇佣信息',
      department: '所属先',
      position: '岗位名称',
      employmentType: '雇佣形态',
      employmentTypeFull: '正式员工',
      employmentTypeContract: '合同制员工',
      employmentTypePartTime: '兼职/临时工',
      employmentTypeOther: '其他',
      probationPeriod: '试用期',
      probationPeriodUnit: '月',
      hireDate: '入职日期',
      resignDate: '离职日期',
      contractEndDate: '合同到期日',
    },
    validation: {
      nameRequired: '请输入姓名',
      nameKanaRequired: '请输入姓名(假名)',
      applicationChannelRequired: '请选择应聘渠道',
      nationalityRequired: '请选择国籍·地区',
      countryRequired: '请选择来自国家',
      birthDateRequired: '请选择出生日期',
      birthdayRequired: '请选择出生日期',
      genderRequired: '请选择性别',
      phoneCountryCodeRequired: '请选择国家区号',
      passportNumberRequired: '请输入护照号码',
      phoneRequired: '请输入手机号码',
      phoneInvalid: '请输入正确的手机号码',
      phoneLengthInvalid: '请输入正确的手机号长度',
      emailRequired: '请输入电子邮箱',
      emailInvalid: '请输入正确的邮箱地址',
      emailFormatInvalid: '请输入正确的邮箱格式',
      residenceCardAddressRequired: '请输入在留卡地址',
      employmentStatusRequired: '请选择求职状态',
      selfPrRequired: '请输入自我推荐',
      reasonForApplicationRequired: '请输入求职动机',
      dependentsInvalid: '请输入有效的数字',
      dependentsNegative: '不能输入负数',
      dependentsMax: '不能超过50',
      departmentRequired: '请选择所属先',
      positionRequired: '请输入岗位名称',
      employmentTypeRequired: '请选择雇佣形态',
      hireDateRequired: '请选择入职日期',
      responsiblePersonRequired: '请选择负责人',
    },
    placeholder: {
      input: '请输入',
      select: '请选择',
      date: 'YYYY-MM-DD',
      month: 'YYYY-MM',
    },
    noData: {
      department: '请先在企业管理中添加所属先',
    },
    residenceInfo: {
      title: '在留卡信息',
      aiParseResidenceCard: 'AI 解析在留卡',
      residenceCardNumber: '在留卡号码',
      residenceStatus: '在留资格',
      industry: '特定行业领域',
      residenceAddress: '居住地',
      employmentRestriction: '就业限制有无',
      cardExpiry: '在留卡期限（到期日）',
      isIndefinite: '无期限',
      permitDate: '许可日期',
      permitType: '许可类型',
      cardIssueDate: '卡片签发日期',
      cardExpiryDate: '有效期到期日',
      outsideActivityPermit: '资格外活动许可',
      specificSkills: {
        title: '特定技能',
        qualificationName: '资格名称',
        acquisitionMonth: '资格取得月',
        industry: '行业',
        certificateNumber: '合格番号',
        add: '添加',
        empty: '尚未添加特定技能',
      },
      japaneseLevel: {
        title: '日语水平',
        qualificationName: '资格名称',
        acquisitionMonth: '资格取得月',
        qualificationLevel: '资格等级',
        add: '添加',
        empty: '尚未添加日语水平',
      },
      otherLanguages: {
        title: '其他语言',
        language: '语言',
        proficiencyLevel: '熟练程度',
        additionalNotes: '补充说明',
        add: '添加',
        empty: '尚未添加其他语言',
        notesLabel: '补充说明：',
      },
      qualifications: {
        title: '保有资格',
        qualificationName: '资格名称',
        acquisitionMonth: '资格取得月',
        additionalNotes: '补充说明',
        add: '添加',
        empty: '尚未添加保有资格',
      },
      validation: {
        qualificationNameRequired: '请选择资格名称',
        acquisitionMonthRequired: '请选择资格取得月',
        industryRequired: '请选择行业',
        industryFieldRequired: '请填写特定产业领域',
        qualificationNameInputRequired: '请输入资格名称',
        qualificationLevelRequired: '请选择资格等级',
        languageRequired: '请选择语言',
        proficiencyLevelRequired: '请选择熟练程度',
      },
    },
    experience: {
      education: {
        title: '教育经历',
        schoolName: '学校名称',
        schoolLocation: '学校所在地',
        degree: '学历',
        major: '专业',
        startDate: '入学日期',
        endDate: '毕业日期',
        graduationStatus: '毕业状态',
        additionalNotes: '补充说明',
        add: '添加',
        empty: '尚未添加教育经历',
      },
      work: {
        title: '职业经历',
        companyName: '公司名称',
        companyLocation: '公司所在地',
        department: '所属部门',
        position: '岗位名称',
        startDate: '入职日期',
        endDate: '离职日期',
        employmentType: '雇佣形态',
        employmentTypeFull: '正式员工',
        employmentTypeContract: '合同制员工',
        employmentTypePartTime: '兼职/临时工',
        employmentTypeOther: '其他',
        reasonForLeaving: '离职理由',
        jobContent: '工作内容',
        add: '添加',
        empty: '尚未添加职业经历',
      },
      validation: {
        schoolNameRequired: '请输入学校名称',
        degreeRequired: '请选择学历',
        majorRequired: '请选择专业',
        startDateRequired: '请选择入学日期',
        companyNameRequired: '请输入公司名称',
        departmentRequired: '请输入所属部门',
        positionRequired: '请输入岗位名称',
        workStartDateRequired: '请选择入职日期',
        employmentTypeRequired: '请选择雇佣形态',
        jobContentRequired: '请输入工作内容',
        residenceTypeRequired: '请选择在留资格',
        industryIdRequired: '请选择特定产业领域',
      },
    },
    documents: {
      title: '其他资料',
      idPhoto: {
        title: '证件照片',
        tips: '前次居留卡相同的照片不可用。限拍摄于6个月以内的照片。限jpg格式，大小在50KB以下。要求无帽并正面朝向，无背景，且清晰。',
        exampleLink: '示例图',
      },
      residenceCard: {
        title: '在留卡',
        titleFront: '上传在留卡',
        tips: '请上传在留卡正面+背面图片，限jpg格式，单个文件需小于 10 MB',
        tips1: '限 jpg/jpeg/png/pdf 格式，单个文件需小于 10 MB',
      },
      passport: {
        title: '护照',
        tips: '限 jpg 格式，单个文件需小于 10 MB',
      },
      designation: {
        title: '指定书',
        tips: '限 jpg 格式，单个文件需小于 10 MB',
      },
      japaneseCertificate: {
        title: '日语能力证书',
        tips: '限 jpg/pdf 格式，单个文件需小于 10 MB',
      },
      skillCertificate: {
        title: '特定技能技能测定考试合格证明书',
        tips: '限 jpg/pdf 格式，单个文件需小于 10 MB',
      },
      resume: {
        title: '简历',
        tips: '限jpg/jpeg/png/doc/xlsx/xls/pdf格式,单个文件需小于10MB',
      },
      other: {
        title: '其他',
        tips: '限jpg/jpeg/png/doc/xlsx/xls/pdf格式,单个文件需小于10 MB',
      },
      emptyImage: '未上传',
      emptyFile: '未上传',
    },
  },
};
